import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconExpand"><Path d="M3.5 10.25V3.5H21.5V15.5H14.75M17.5 10.5V7.5H14.5M14 11L17.2512 7.74876M11.5 13.5H2.5V21.5H11.5V13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconExpand;
